import http from "./http-common";

class SlotService {
    queryString(payload) {
        return Object.keys(payload)
          .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
          .join("&");
      }

      GetSlotDetails(payload) {
        const queryString = this.queryString(payload);
        return http.get(`/appointmentTemplate/list/filter?${queryString}`);
      }

      SaveSlot(payload) {
        return http.post(`appointmentTemplate/save`,payload);
      }

      InActiveSlots(id) {
        return http.put(`appointmentTemplate/updateStatus/${id}`);
      }

}

export default new SlotService();
